<template>
  <div class="archived-contracts container container_30">
    <searcher @compose-filters="loadFilteredContracts"/>

    <md-table class="archived-contracts__table">
      <template v-if="list.length">
        <md-table-row class="archived-contracts_row">
          <md-table-head>{{ i18n.cont_counterparty() }}</md-table-head>
          <md-table-head>{{ i18n.cont_contract_number() }}</md-table-head>
          <md-table-head>{{ i18n.lbl_start_date() }}</md-table-head>
          <md-table-head>{{ i18n.lbl_end_date() }}</md-table-head>
          <md-table-head><!--Button--></md-table-head>
        </md-table-row>
        <template v-for="(item, i) in list">
          <md-table-row class="archived-contracts__row" :key="i">
            <md-table-cell class="archived-contracts__table-cell counterparty-cell">
              <company-name-getter :id="item.contractor" />
            </md-table-cell>
            <md-table-cell class="archived-contracts__table-cell contract-number-cell">{{ item.contractNumber }}</md-table-cell>
            <md-table-cell class="archived-contracts__table-cell">{{ i18n.d(item.startDate) }}</md-table-cell>
            <md-table-cell class="archived-contracts__table-cell">{{ i18n.d(item.endDate) }}</md-table-cell>
            <md-table-cell class="archived-contracts__table-cell">
              <md-button class="contract-requests__view-details-btn md-icon-button"
                        @click="openDetails(item.id)">
                <md-icon>keyboard_arrow_right</md-icon>
              </md-button>
            </md-table-cell>

          </md-table-row>
        </template>
         <md-table-row v-if="!isLoaded">
            <md-table-cell colspan="7">
                <div class="archived-contracts__btn-outer">
                <md-button @click="more" :disabled="isLoading">{{ i18n.lbl_view_more() }}</md-button>
                </div>
            </md-table-cell>
         </md-table-row>
      </template>
      <template v-else>
        <div class="archived-contracts__no-contracts">
          <md-icon class="md-size-4x">trending_up</md-icon>
          <h2>{{ i18n.cont_no_archived_contracts() }}</h2>
          <p>{{ i18n.cont_no_archived_contracts_desc() }}</p>
        </div>
      </template>
    </md-table>
  </div>
</template>

<script>
import Searcher from '../Contracts.Searcher'
import CompanyNameGetter from '@vue/app/common/CompanyNameGetter'
import get from 'lodash/get'

import { mapGetters, mapActions } from 'vuex'
import { i18n } from '@js/i18n'
import { documentTypes,
  ASSET_POLICIES_VERBOSE,
  CONTRACTS_DETAILS_TYPES } from '@const'
import { vuexTypes } from '@vuex/types'
import { EventDispatcher } from '@js/events/event_dispatcher'

export default {
  components: { Searcher,
    CompanyNameGetter },
  data: _ => ({
    i18n,
    documentTypes,
    isLoading: false,
    ASSET_POLICIES_VERBOSE,
    filters: {
      counterparty: '',
      contractNumber: '',
      startTime: '',
      endTime: '',
      source: '',
      isCompleted: true
    }
  }),

  async created () {
    await this.loadFilteredContracts()
  },

  computed: {
    ...mapGetters([
      vuexTypes.archivedContracts,
      vuexTypes.accountId
    ]),
    list () {
      return get(this.archivedContracts, 'records', [])
    },
    isLoaded () {
      return get(this.archivedContracts, 'isLoaded')
    }
  },

  methods: {
    ...mapActions({
      loadList: vuexTypes.GET_ARCHIVED_CONTRACTS,
      loadNext: vuexTypes.NEXT_ARCHIVED_CONTRACTS
    }),

    async more () {
      this.isLoading = true
      try {
        await this.loadNext()
      } catch (e) {
        console.error(e)
        EventDispatcher.dispatchShowErrorEvent(i18n.th_failed_to_load_tx())
      }
      this.isLoading = false
    },
    loadFilteredContracts (filters) {
      this.filters.source = this.accountId
      if (filters) {
        this.filters.counterparty = filters.counterparty
        this.filters.contractNumber = filters.contractNumber
        this.filters.startTime = filters.startDate
        this.filters.endTime = filters.endDate
      }
      return this.loadList(this.filters)
    },
    openDetails (id) {
      this.$emit('open-details', {id: id, type: CONTRACTS_DETAILS_TYPES.archived})
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~scss/mixins";
  @import "~scss/variables";

  .archived-contracts {
    background: $default-white;
  }

  .archived-contracts__table {
    margin-top: 1.5rem;
    // md-card styles
    border-radius: 2px;
    box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.08);
  }

  .counterparty-cell {
    width: 30%;
  }

  .contract-number-cell {
    width: 20%;
  }

  .archived-contracts__view-details-btn {
    float: right;
  }

  .archived-contracts__no-contracts {
    margin: 1rem auto;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/contracts/index/archive/Contracts.ArchivedList.vue